import { inject, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { BaseApiService } from '@app/core/api/base-api.service';
import { BusinessEntityDto } from '@stores/business-entities';

@Injectable({ providedIn: 'root' })
export class BusinessEntitiesService {
  private readonly api = inject(BaseApiService);
  private readonly apiVersion = 'v1';
  private readonly resourcePath = `${this.apiVersion}/tenants`;

  getBusinessEntities(
    tenantUuid: string,
    page?: number,
    size?: number,
  ): Observable<BusinessEntityDto[]> {
    type ApiBusinessEntity = BusinessEntityDto;
    let params = new HttpParams();
    if (page && size) {
      params.set('page', String(page)).set('size', String(size));
    }
    return this.api
      .get<readonly ApiBusinessEntity[]>(`${this.resourcePath}/${tenantUuid}/entities`, { params })
      .pipe(map((arr) => (Array.isArray(arr) ? arr : [])));
  }
}
